//@ts-nocheck
import { useMutation } from '@tanstack/react-query';
import { supabase } from '../../api';

const updateAvailabilityForDuration = async (teamId, date, startTime, duration, record_id) => {
    console.log("Отправленное время:", duration);
    // Разбиваем startTime на часы и минуты
    const [startHours, startMinutes] = startTime?.split(':').map(Number);

    // Вычисляем время окончания интервала
    const durationEnd = new Date();
    durationEnd.setHours(startHours);
    durationEnd.setMinutes(startMinutes + duration);

    const endHours = String(durationEnd.getHours()).padStart(2, '0');
    const endMinutes = String(durationEnd.getMinutes()).padStart(2, '0');
    const calculatedEndTime = `${endHours}:${endMinutes}`;

    console.log("Calculated end time:", calculatedEndTime);

    // Получаем все записи, которые пересекаются с указанным интервалом
    const { data, error } = await supabase
        .from('teams_availability')
        .select('*')
        .eq('team_id', teamId)
        .eq('date', date)
        .filter('start_time', 'lt', calculatedEndTime)
        .filter('end_time', 'gt', startTime);

    if (error) {
        throw new Error(error.message);
    }

    console.log("Found overlapping slots2:", data);

    // Отсортируем записи по `start_time`
    const sortedSlots = data.sort((a, b) => a.start_time.localeCompare(b.start_time));

    // Проверяем, достаточно ли слотов для указанного `duration`
    let totalDuration = 0;
    const slotsToBook = [];

    for (const slot of sortedSlots) {
        const slotStart = new Date(`1970-01-01T${slot.start_time}Z`);
        const slotEnd = new Date(`1970-01-01T${slot.end_time}Z`);
        const slotDuration = (slotEnd - slotStart) / (1000 * 60); // Длительность в минутах

        totalDuration += slotDuration;
        slotsToBook.push(slot.id);

        if (totalDuration >= duration) {
            break;
        }
    }

    // Если недостаточно слотов для указанного duration
    if (totalDuration < duration) {
        throw new Error('Not enough available slots to book the requested duration.');
    }

    // Обновляем поле is_available в найденных записях
    const { error: updateError } = await supabase
        .from('teams_availability')
        .update({ is_available: false, record_id })
        .in('id', slotsToBook);

    if (updateError) {
        throw new Error(updateError.message);
    }

    console.log(`Updated ${slotsToBook.length} slots as unavailable.`);

    return { success: true };
};

export default function useUpdateMultiAvailabilityTime() {
    return useMutation(
        ({ teamId, date, startTime, duration, record_id }: { teamId: string, date: string, startTime: string, duration: number, record_id: number }) => 
            updateAvailabilityForDuration(teamId, date, startTime, duration, record_id),
        {
            onSuccess: async (data) => data,
        }
    );
}
